import type { Maybe } from "graphql/jsutils/Maybe";
import { memo, useCallback } from "react";
import * as Styled from "./style";
import { runningInBrowser } from "~/const/browser";
import { useMatchMedia } from "~/hooks/use-match-media";
import type { G_VideoAppUrlScheme } from "~/lib/graphql";
import { platform } from "~/lib/navigator/user-agent";

type VodVrProps = {
  windowsURLSchemes: Maybe<G_VideoAppUrlScheme[]> | undefined;
  iosURLSchemes: Maybe<G_VideoAppUrlScheme[]> | undefined;
  androidURLSchemes: Maybe<G_VideoAppUrlScheme[]> | undefined;
};

export const VodVr = memo((props: VodVrProps) => {
  const { windowsURLSchemes, iosURLSchemes, androidURLSchemes } = props;

  const { isSpSize } = useMatchMedia();

  const handleVodVrPartBtnPressed = useCallback((schemeUrl: string) => {
    if (!runningInBrowser) return;
    location.href = schemeUrl;
  }, []);

  const existWindowsURLSchemes =
    windowsURLSchemes !== undefined && windowsURLSchemes !== null && windowsURLSchemes.length > 0;

  if (platform === "Windows" && existWindowsURLSchemes) {
    return (
      <Styled.DivFlexContainer>
        <Styled.DivGridButtonSpace>
          {windowsURLSchemes.map((item, idx) => {
            return (
              <Styled.Button
                key={`PartButton-${idx}`}
                name="パートボタン"
                mainText={`パート${item.partNumber}`}
                iconName="play"
                iconColor="GRAY50"
                iconSize={isSpSize ? "L" : "XL"}
                fontSize={isSpSize ? "S" : "M"}
                color="GRAY50"
                bgColor="YELLOW900"
                onClick={() => handleVodVrPartBtnPressed(item.url)}
              />
            );
          })}
        </Styled.DivGridButtonSpace>
      </Styled.DivFlexContainer>
    );
  }

  const existIosURLSchemes = iosURLSchemes !== undefined && iosURLSchemes !== null && iosURLSchemes.length > 0;

  if (platform === "iOS" && existIosURLSchemes) {
    return (
      <Styled.DivFlexContainer>
        <Styled.DivGridButtonSpace>
          {iosURLSchemes.map((item, idx) => {
            return (
              <Styled.Button
                key={`PartButton-${idx}`}
                name="パートボタン"
                mainText={`パート${item.partNumber}`}
                iconName="play"
                iconColor="GRAY50"
                iconSize={isSpSize ? "L" : "XL"}
                fontSize={isSpSize ? "S" : "M"}
                color="GRAY50"
                bgColor="YELLOW900"
                onClick={() => handleVodVrPartBtnPressed(item.url)}
              />
            );
          })}
        </Styled.DivGridButtonSpace>
      </Styled.DivFlexContainer>
    );
  }

  const existAndroidURLSchemes =
    androidURLSchemes !== undefined && androidURLSchemes !== null && androidURLSchemes.length > 0;

  if (platform === "Android" && existAndroidURLSchemes) {
    return (
      <Styled.DivFlexContainer>
        <Styled.DivGridButtonSpace>
          {androidURLSchemes.map((item, idx) => {
            return (
              <Styled.Button
                key={`PartButton-${idx}`}
                name="パートボタン"
                mainText={`パート${item.partNumber}`}
                iconName="play"
                iconColor="GRAY50"
                iconSize={isSpSize ? "L" : "XL"}
                fontSize={isSpSize ? "S" : "M"}
                color="GRAY50"
                bgColor="YELLOW900"
                onClick={() => handleVodVrPartBtnPressed(item.url)}
              />
            );
          })}
        </Styled.DivGridButtonSpace>
      </Styled.DivFlexContainer>
    );
  }

  return null;
});

VodVr.displayName = "VodVr";
